import { render, staticRenderFns } from "./test_info.vue?vue&type=template&id=7c8ee07b&scoped=true&"
import script from "./test_info.vue?vue&type=script&lang=ts&"
export * from "./test_info.vue?vue&type=script&lang=ts&"
import style0 from "./test_info.vue?vue&type=style&index=0&id=7c8ee07b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8ee07b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VTextField})
